import { render } from "./BannerRegComponent.vue?vue&type=template&id=095fd374&scoped=true&ts=true"
import script from "./BannerRegComponent.vue?vue&type=script&lang=ts"
export * from "./BannerRegComponent.vue?vue&type=script&lang=ts"

import "./BannerRegComponent.vue?vue&type=style&index=0&id=095fd374&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095fd374"]])

export default __exports__